export const language = {
  gateway: 'درگاه پرداخت',
  bank: 'بانک',
  transferringTo: (destination: string) => `درحال انتقال به صفحه ${destination} هستید.`,
  pleaseWait: 'لطفا صبر کنید ...',
};
